import { SelectOption } from '@/features/editMode/types/selectOption';
import { Notification } from '@/features/notifications/types/Notification';

export const filterAndSortNotificationsByStatus = (notifications: Notification[], statusOption?: SelectOption) => {
  return notifications
    .filter((notification) => notification.notificationStatusId === +(statusOption?.value || 0))
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
};
